import { useEffect } from "react"
import { useGetStores } from "../stores/queries";
import { useLocation, useHistory } from 'react-router-dom';
import { useSelector } from "react-redux";

const useValidStoreId = () => {
    const { isLoading: isGetStoresLoading, data: stores } = useGetStores(true);
    const { user } = useSelector((state) => state.user);
    const location = useLocation();
    const history = useHistory();

    const isValidStoreId = (storeId: string) => {
        return stores?.some((store) => store._id === storeId);
    };
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        if (stores?.length) {
            const initialStore = user.store || stores[0]._id;
            if ((searchParams.get('storeId') || searchParams.get('storeId') === '') && !isValidStoreId(searchParams.get('storeId'))) {
                searchParams.set('storeId', initialStore);
            } else if (!searchParams.get('storeId') || !isValidStoreId(searchParams.get('storeId'))) {
                // const params = new URLSearchParams({ storeId: storeId || '' });
                searchParams.append('storeId', initialStore);
            }
            history.replace({
                pathname: location.pathname, search: searchParams.toString(),
                state: { storeID: searchParams.get('storeId') }
            });
        }
    }, [stores, location.search]);
}

export default useValidStoreId;